import React from 'react';
import { Alert, Title, Text, Flex, Link } from '@gjensidige/builders-components';
import { IPricingQuestion } from '../../interfaces/EnquiryInterface';
import { AdditionalInputs } from '../../interfaces/Types';
import { AppConstants } from '../../utils/AppConstants';
import { AddedInputsSection } from './AddedInputsSection';
import { AddInputsWidget } from './AddInputsWidget';
import { InformationModal } from '../Common/InformationModal/InformationModal';
interface AdditionalInputProps {
  additionalModalInputs: IPricingQuestion[];
  addedInputs?: AdditionalInputs[];
  isMaxQuestionsReached: boolean;
  isAboveAreaThreshold: boolean;
  additionalInputsDetails: {
    linkText: string;
    description: {
      title?: string;
      details: string;
    }[]
  };
  addAdditionalQuestions: () => void;
  onEditButtonClick: (item: AdditionalInputs) => void;
  updateAdditionalQuestions: (itemIndex: number) => void;
  deleteAdditionalQuestion: (itemIndex: number) => void;
  resetAdditionalQuestions: () => void;
  handleModalInputChange: (
    type: string,
    value: string,
    isValid?: boolean
  ) => void;
}
export const AdditionalInputsSection: React.FC<AdditionalInputProps> = (
  props: AdditionalInputProps
) => {

  const renderAlerts = () => {
      return (
        <div className="additional-questions-alert mt-2 mb-1">
          {
          props.isAboveAreaThreshold 
            ? (
              <Alert
                variant="filled"
                severity="warning"
              >
               <Title>Övriga byggnader har för stor byggyta</Title>
                <Text>
                  Vi kan tyvärr inte lämna pris via hemsidan eftersom dina övriga byggnader har för stor total byggyta. 
                </Text>
                <Flex>
                  <Link 
                    href="https://www.gjensidige.se/privat/kundservice"
                    target='_blank'
                    icon={false}
                  >
                    Kontakta oss så hjälper vi dig.
                  </Link>

                </Flex>
              </Alert>
            )
            :
              <>
                { props.isMaxQuestionsReached && (
                    <Alert
                      variant="outlined"
                      severity="informative"
                    >
                      <p
                        dangerouslySetInnerHTML={{
                          __html: AppConstants.getAppText(
                            'webshop.villa.extraBuildingExceedsThresholdMessage'
                          )
                        }}
                      ></p>
                    </Alert>
                  )}
              </>
          }
        </div>
      );
    
  }

  return (
    <>
      <div className="add-inputs-widget">
        {props?.addedInputs && props?.addedInputs.length > 0 && (
          <div className="added-inputs-wrapper mb-md-3">
            {props.addedInputs.map((item: AdditionalInputs, index: number) => {
              return (
                <div key={index}>
                  <AddedInputsSection
                    item={item}
                    editIndex={index}
                    handleEditInputClick={() => props.onEditButtonClick(item)}
                    handleModalInputChange={props.handleModalInputChange}
                    additionalModalInputs={props.additionalModalInputs}
                    updateAdditionalQuestions={props.updateAdditionalQuestions}
                    deleteAdditionalQuestion={props.deleteAdditionalQuestion}
                  />
                </div>
              );
            })}
          </div>
        )}

        <AddInputsWidget
          addInputsSectionLabel={AppConstants.getAppText(
            'webshop.villa.addAdditionalBuildingLabel'
          )}
          handleModalInputChange={props.handleModalInputChange}
          additionalModalInputs={props.additionalModalInputs}
          addAdditionalQuestions={props.addAdditionalQuestions}
          resetAdditionalQuestions={props.resetAdditionalQuestions}
          hideAddInputsButton={props.isMaxQuestionsReached || props.isAboveAreaThreshold}
        />
      </div>
      {renderAlerts()}
      {props.additionalInputsDetails?.linkText &&
        <div className="pt-1">
          <InformationModal
            linkText={props.additionalInputsDetails?.linkText}
            modalContent={props.additionalInputsDetails?.description}
            leftAlignedLink
            ariaDescribedBy="add-additional-inputs-info"
            modalAriaLabel="Hjälp om övriga byggnader"
          />
        </div>
      }
    </>
  );
};
